import React, { createContext, useState } from "react";

const Context = createContext({
    color: 2,
    setColor: (c) => {}
})

export const ContextProvider = props =>{

    const[color,setColor] = useState(2)

    const setColorHandler = (c) => setColor(c)
    
    return <Context.Provider value={{color:color, setColor: setColorHandler }} > {props.children} </Context.Provider>

}


export default Context